import { render, staticRenderFns } from "./modifyuser2.vue?vue&type=template&id=0ccec674"
import script from "./modifyuser2.vue?vue&type=script&lang=js"
export * from "./modifyuser2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports